import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { FRONT_CONTENT_NAMES } from 'app/front-pages/shared/constants/front-content-names';
import { PagesFrontMenuEntry } from 'app/front-pages/shared/interfaces/pages-front-menu-entry.interface';
import {  ContentService } from 'app/shared/services';
@Component({
  selector: 'app-front-footer',
  templateUrl: './front-footer.component.html',
  styleUrls: ['./front-footer.component.css']
})
export class FrontFooterComponent implements OnInit {
  userMenuEntries: PagesFrontMenuEntry[];
  userName = 'default';


  menuEntries: PagesFrontMenuEntry[] = [
    {
      title: 'Home',
      menuName: FRONT_CONTENT_NAMES.HOME
    },
    {
      title: 'About_Single_Window',
      menuName: FRONT_CONTENT_NAMES.About_Single_Window
    },
    {
      title: 'Services',
      menuName: FRONT_CONTENT_NAMES.Services
    },
    {
      title: 'Support_and_Assistance',
      menuName: FRONT_CONTENT_NAMES.Support_and_Assistance
    },
 
  ];

  translate:TranslateService;
  constructor(
    private contentService: ContentService,
 
    private router: Router,
    private route: ActivatedRoute,
    private translateService:TranslateService
  ) {
    this.translate=translateService;

  }

  ngOnInit() {
  
    this.generateMenu();
  }

  private generateMenu() {
    this.setMenuEntries();
  }


  private setMenuEntries() {
    // Populates the front pages menu entry list

    this.userMenuEntries = [];
    for (const menuEntry of this.menuEntries) {
      const menuName = menuEntry.menuName;
      
        this.userMenuEntries.push(
          this.menuEntries.find(
            newMenuEntry => newMenuEntry.menuName === menuName
          )
        );
      
    }
  }
  
  setContent(contentName: string) {
 
    //routing to the pages name
    this.router.navigate([`/${contentName}`]);
  }



}



// WEBPACK FOOTER //
// ./src/app/front-pages/Layouts/front-footer/front-footer.component.ts